<div class="custom-modal novo-envio-cte">
  <div class="header">
    <h1 mat-dialog-title>Configuração de Envio de CT-e</h1>
    <div>
      <mat-icon class="help-icon" customTooltip="#cadastro.manutencao-envio-cte">help</mat-icon>
      <mat-icon mat-dialog-close="cancel">close</mat-icon>
    </div>
  </div>
  <div *ngIf="isLoading" class="d-flex justify-content-center align-items-center" style="height: 170px">
    <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
  </div>
  <form [formGroup]="formDadosConfiguracao" *ngIf="!isLoading" style="margin-bottom: 15px;" (ngSubmit)="salvarDados()">
    <div mat-dialog-content>
      <div>
        <mat-horizontal-stepper linear="false" #stepper>
          <mat-step [stepControl]="formDadosBasicos" formGroupName="basicos">
            <ng-template matStepLabel>Dados da Configuração</ng-template>
            <h3 style="font-size: 14px;">DADOS BÁSICOS</h3>

            <div class="element-inline">
              <mat-form-field>
                <mat-label>Nome da Configuração:</mat-label>
                <input matInput formControlName="descricaoEnvioXml" required
                  customTooltip="descricaoEnvioXml#cadastro.manutencao-envio-cte" />
              </mat-form-field>

              <mat-form-field>
                <mat-label>Atraso para envio em Horas:</mat-label>
                <input matInput formControlName="tempoDelayEnvioXml" somenteNumeros required
                  customTooltip="tempoDelayEnvioXml#cadastro.manutencao-envio-cte" />
              </mat-form-field>

              <mat-form-field>
                <mat-label>Tipo de Envio:</mat-label>
                <mat-select formControlName="tipoEnvio" required (selectionChange)="consultaParams()"
                  placeholder="Tipo de Envio" customTooltip="tipoEnvio#cadastro.manutencao-envio-cte">
                  <mat-option disabled selected value="">Selecione</mat-option>
                  <mat-option *ngFor="let r of listaTipoEnvioCTE" [value]="r.envioTipoId">
                    {{ r.descricao }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-slide-toggle style="flex-grow: 0;" color="primary" formControlName="statusEnvioXml"
                customTooltip="statusEnvioXml#cadastro.manutencao-envio-cte">Ativo</mat-slide-toggle>
            </div>

            <h3 style="font-size: 14px;">CLIENTES</h3>
            <div class="element-inline">
              <mat-form-field style="width: 100%;">
                <mat-label>Clientes que utilizam essa configuração</mat-label>
                <mat-select
                formControlName="clienteSelecionado"
                disableOptionCentering="true"
                placeholder="Cliente"
              >
                <mat-option><ngx-mat-select-search [formControl]="clienteMultiFilter" placeholderLabel="Buscar..."
                noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
                <mat-option
                  *ngFor="let cliente of filteredClientes | async"
                  [value]="cliente?.id"
                >
                  {{ cliente?.nome }}
                </mat-option>
              </mat-select>
              </mat-form-field>
              <p class="float-right text-center">
                <button mat-flat-button color="primary" type="button" 
                  (click)="modalProdutosCliente(getClienteSelecionado)">Produtos</button>
                <br><small *ngIf="getClienteSelecionado?.length === 1">
                  {{produtosProvisorios == '' || null ? 'Todos' : produtosProvisorios?.length}}
                  {{produtosProvisorios?.length === 1 ? 'produto' : 'produtos'}} </small>
              </p>
            </div>

            <div class="element-inline" *ngIf="formDadosBasicos.get('tipoEnvio')?.value !== 3">
              <h3 style="font-size: 14px;">FILTROS POR TIPO DE DOCUMENTO E PROCESSAMENTO</h3>
              <mat-form-field>
                <mat-label>Tipo CTe</mat-label>
                <mat-select formControlName="tipoCte"  multiple #selectCTE placeholder="Tipo CTe"
                  customTooltip="tipoCte#cadastro.manutencao-envio-cte">
                  <mat-option [value]="" (click)="toggleAllSelectionCTE()">Todos</mat-option>
                  <mat-option *ngFor="let r of listaTipoCTE" [value]="r.id">
                    {{ r.descricao }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field>
                <mat-label>Tipo de Processamento</mat-label>
                <mat-select formControlName="tipoDeProcessamento" multiple placeholder="Tipo Procesamento"
                  customTooltip="tipoDeProcessamento#cadastro.manutencao-envio-cte" #selectTipoProcessamento>
                  <mat-option [value]="" (click)="toggleAllSelectionTipoProcessamento()">Todos</mat-option>
                  <mat-option *ngFor="let r of listaTipoProcessamento" [value]="r.id">
                    {{ r.tipoProcessamento }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </mat-step>

          <mat-step [stepControl]="parametros">
            <ng-template matStepLabel>Parâmetros</ng-template>
            <div *ngIf="stepper.selectedIndex == 1" class="parametros-tipo-envio" formGroupName="parametros">
              <div class="element-inline">
                <div *ngFor="let param of tipoParams; let i=index">

                  <mat-form-field *ngIf="!param.paramValidation">
                    <mat-label>{{param.descricao}}</mat-label>
                    <input matInput [formControlName]="'param_'+param.envioTipoParamsId" [value]="param.valor"
                      [placeholder]="param.descricao" [customTooltip]="param.chave+'#cadastro.manutencao-envio-cte'" />
                  </mat-form-field>

                  <mat-form-field *ngIf="param.paramValidation == 'select-single' ">
                    <mat-label>{{param.descricao}}</mat-label>
                    <mat-select [formControlName]="'param_'+param.envioTipoParamsId" required
                      [placeholder]="param.descricao" [customTooltip]="param.chave+'#cadastro.manutencao-envio-cte'">
                      <mat-option *ngFor="let r of param.paramOptions?.split('|') ||[]" [value]="r">
                        {{ r }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field *ngIf="param.paramValidation =='email-multiple'">
                    <mat-label>{{param.descricao}}</mat-label>
                    <input matInput [formControlName]="'param_'+param.envioTipoParamsId" [placeholder]="param.descricao"
                      [customTooltip]="param.chave+'#cadastro.manutencao-envio-cte'" />
                  </mat-form-field>

                </div>
              </div>
            </div>
          </mat-step>
        </mat-horizontal-stepper>
      </div>
    </div>
    <mat-dialog-actions align="end">
      <button type="button" mat-button *ngIf="stepper.selectedIndex > 0" (click)="stepper.previous();"> Voltar </button>
      <button type="button" mat-button [disabled]="formDadosBasicos.invalid" *ngIf="stepper.selectedIndex == 0"
        (click)="stepper.next()">Próximo</button>
      <button type="submit" mat-raised-button color="primary" [hidden]="stepper.selectedIndex == 0"
        [disabled]="stepper.selectedIndex == 0 || parametros.invalid">Salvar</button>
    </mat-dialog-actions>
  </form>
</div>
